export const ILLNESS = {
  nickname: 'PRODUCTS.ILLNESS.nickname',
  lifeInsurance: true,
  icon:'illness'
};
